import { IPlayerProps, Player } from '@lottiefiles/react-lottie-player';
import React, { FunctionComponent } from 'react';
import styles from './loader-component.module.scss';
import RSLoader from './rs-loader.json';

type LoaderProps = {
  size?: 'default' | 'small';
};

export const Loader: FunctionComponent<LoaderProps> = ({ size = 'default' }) => {
  const width = size === 'default' ? 80 : 40;
  const height = size === 'default' ? 80 : 40;

  const options: IPlayerProps = {
    background: 'transparent',
    speed: 1,
    loop: true,
    autoplay: true,
    src: RSLoader,
    rendererSettings: {
      preserveAspectRatio: 'xMinYMin slice',
    },
    style: { margin: 0, width: width, height: height },
  };

  return (
    <div className={styles['loader-component']}>
      <Player {...options} />
    </div>
  );
};

export default Loader;
